module.exports = __webpack_public_path__ + "img/responseNum.fb78744.png";